import { useChexContext } from "checkout-experience/providers/chex-context-wrapper";
import { PaymentType } from "checkout-query-client/types/form-types";

export const useSecurityCodeRequired = (paymentType?: PaymentType) => {
  const { merchantSettings } = useChexContext();

  const paymentMethods = merchantSettings?.paymentMethods;

  return (
    paymentType === PaymentType.creditCard &&
    paymentMethods?.[paymentType]?.captureSecurityCodeOnPayWithProfile
  );
};
